<template>
  <el-dialog
    title="开发接入信息"
    :visible="dialogShow"
    :before-close="beforeClose"
    width="614px"
    class="account-info-dialog"
  >
    <div>
      <div class="list-item"><span class="label">公众号:</span>{{account.name}}</div>
      <div class="list-item"><span class="label">token:</span>{{account.token}}</div>
      <div class="list-item"><span class="label">aesKey:</span>{{account.aesKey}}</div>
      <div class="list-item">
        <span class="label">接入链接:</span>
        <span v-html="accessUrl"></span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogShow:{
      type: Boolean,
      default: false,
    },
    account: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  computed: {
    accessUrl() {
      let host = location.host;
      if(/^(\d(.\d){3})|localhost/.test(host)){
        host='<span class="text-red">正式域名</span>'
      }
      return 'http://' + host + '/wx/wx/msg/' + this.account.appid
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
    }
  },
}
</script>
<style lang="scss" scoped>
.account-info-dialog {
  /deep/ .el-dialog__header {
    background: #F8F8F8;
    padding-bottom: 20px;
  }
}
.list-item{
  line-height: 30px;
}
.label{
  width: 100px;
  display: inline-block;
  margin-right: 10px;
  font-weight: bold;
  text-align: right;
}
</style>
